var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base"},[_c('div',{staticClass:"base-title"},[_vm._v("课程详情")]),_c('EditorView',{attrs:{"data":_vm.data.introduce}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }